import { render, staticRenderFns } from "./MenuAdminicular.vue?vue&type=template&id=1b9ea04b&scoped=true"
import script from "./MenuAdminicular.vue?vue&type=script&lang=js"
export * from "./MenuAdminicular.vue?vue&type=script&lang=js"
import style0 from "./MenuAdminicular.vue?vue&type=style&index=0&id=1b9ea04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ea04b",
  null
  
)

export default component.exports